import {NavLink} from 'react-router-dom';
import styled from 'styled-components';

import {colors, font, inputFieldBase, textEllipsis, transition} from 'theme';

export const TabsContainer = styled.div`
    width: 100%;
    display: flex;
`;

export const Link = styled(NavLink)`
    position: relative;
    flex: 1;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.textPrimary};
    text-decoration: none;
    box-sizing: border-box;
    border-bottom: 1px solid ${colors.textMuted};
    text-transform: uppercase;
    font-family: ${font.family.primary};
    font-size: 13px;
    font-weight: 700;

    :hover {
        color: ${colors.brandPrimary};
    }

    &.active {
        color: ${colors.brandPrimary};

        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 3px;
            background-color: ${colors.brandPrimary};
        }
    }
`;

export const TextareaElem = styled.textarea<{
    hasError?: boolean;
    disabled?: boolean;
}>`
    ${textEllipsis};
    ${(p) => inputFieldBase(p.disabled ? 'disabled' : p.hasError ? 'error' : 'normal')};

    display: block;
    width: 100%;
    box-sizing: border-box;
    height: 80px;
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'text')};
    transition: border-color ${transition.duration};
    resize: none;
    white-space: normal;
    overflow-y: auto;

    &::-webkit-input-placeholder {
        color: ${colors.border};
    }

    &::-moz-placeholder {
        color: ${colors.border};
    }

    &:-ms-input-placeholder {
        color: ${colors.border};
    }

    &::-ms-input-placeholder {
        color: ${colors.border};
    }

    &::-ms-clear {
        display: none;
    }
`;
